/*  ========================================================================
    # Sections - History Timeline Entry
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import LazyImage from '@/react/components/LazyImage';
import { useInView } from 'react-intersection-observer';
import bem from '@/react/utils/bem';

const HistoryTimelineEntry = ({ year, title, description, image }) => {
  const {
    ref: entryRef,
    inView,
    entry
  } = useInView({
    threshold: 0.5,
    triggerOnce: true
  });

  return (
    <div
      className={`${bem('s-history-timeline', 'entry-wrapper', { show: inView })}`}
      ref={entryRef}
    >
      <div
        className={`${bem('s-history-timeline', 'entry', { image })} tw-w-full ${image ? 'xl:tw-w-5/12' : 'xl:tw-w-4/12'}`}
      >
        {image ? (
          <LazyImage
            figureClass='s-history-timeline__entry-image'
            defaultUrl={image['sizes']['medium']}
            alt={image['alt']}
            placeholderUrl={image['sizes']['placeholder']}
          ></LazyImage>
        ) : null}
        <div className='s-history-timeline__entry-content'>
          <span className='u-subheadline'>{year}</span>
          <p className='h4'>{title}</p>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

HistoryTimelineEntry.propTypes = {
  year: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.array
};

export default HistoryTimelineEntry;
